import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/context/constructor.js";
import { useThisContext } from "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import { selectBooking } from "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const props = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const vehicleItem = useThisContext();
  const booking = useAppSelector(selectBooking);
  const isMissingCredentials = !booking.spaceId || !booking.envId || !booking.collectionId;
  const isHidden = !booking.enable || !vehicleItem || isMissingCredentials;
  const config = useMemo(() => {
    if (isHidden) {
      return null;
    }
    return {
      apiRoot: booking.apiRoot,
      spaceId: booking.spaceId,
      envId: booking.envId,
      collectionId: booking.collectionId,
      fields: {
        name: { label: t("widgets.bookingRequest.name") },
        surname: { label: t("widgets.bookingRequest.surname") },
        email: { label: t("widgets.bookingRequest.email") },
        phone: { label: t("widgets.bookingRequest.phone") }
      },
      elements: {
        title: {
          children: t("widgets.bookingRequest.title"),
          ...booking.title
        },
        subTitle: booking.subTitle,
        disclaimer: {
          children: t("widgets.bookingRequest.disclaimer"),
          ...booking.disclaimer
        },
        agreement: booking.agreement ?? [
          {
            level: "small",
            color: "dark",
            children: t("widgets.bookingRequest.agreement")
          }
        ],
        button: {
          type: "primary",
          children: t("widgets.bookingRequest.submit"),
          ...booking.button
        },
        alert: {
          success: {
            message: t("widgets.bookingRequest.alert.success")
          },
          error: {
            message: t("widgets.bookingRequest.alert.error")
          }
        }
      },
      vehicle: {
        id: vehicleItem == null ? void 0 : vehicleItem.id,
        collection_id: vehicleItem == null ? void 0 : vehicleItem.collectionId
      }
    };
  }, [vehicleItem, booking, isHidden, t]);
  return {
    ...props,
    config,
    t
  };
};
export {
  useContainer
};
